"use client"
import styled from "@emotion/styled"
import CookieBanner from "components/CookieBanner/CookieBanner"
import { AppType, AppTypeProvider } from "contexts/AppTypeProvider"
import { LayoutProvider } from "contexts/LayoutProvider"
import { OneLinkScriptProvider } from "contexts/OneLinkScript"
import { usePathname } from "next/navigation"
import { FC, Suspense, useEffect, useRef } from "react"
import Analytics from "reusable/Analytics"
import { Desktop, Mobile } from "ui"
import DesktopHeader from "./DesktopHeaderCharge"
import FooterCharge from "./FooterCharge"
import MobileMenuCharge from "./MobileMenuCharge"

const StyledMain = styled.div<{ isParking: boolean; isContent: boolean }>`
  flex-grow: 1;
  padding-top: 64px;
  overflow-x: hidden;

  ${(props) => props.theme.breakpoints.up("md")} {
    /* padding-top: ${(props) => (props.isContent ? "0px" : "98px")}; */
    padding-top: 98px;
    height: ${(props) => (props.isParking ? "100vh" : "auto")};
  }

  :focus {
    outline: 0;
  }
`
const SkipLink = styled.a`
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  border: 0;
  white-space: nowrap;

  &:focus-visible {
    width: auto;
    height: auto;
    margin: 0;
    overflow: visible;
    clip: auto;
    top: 0;
    inset-inline-start: 0;
    background: #000;
    color: #fff;
    padding: 8px;
    z-index: 100;
  }
`

const PazChargeLayout: FC<any> = ({ locale, children, menu_data, footer_data, cookie_consent_data }) => {
  const mainRef = useRef<HTMLDivElement>(null)
  const pathname = usePathname()
  useEffect(() => {
    if (typeof window !== "undefined" && navigator.serviceWorker) {
      navigator.serviceWorker.getRegistrations().then((registrations) => {
        for (const registration of registrations) {
          registration.unregister()
        }
      })
    }
  }, [])

  return (
    <OneLinkScriptProvider>
      <AppTypeProvider initialAppType={AppType.Charge}>
        <LayoutProvider>
          <SkipLink href="#mainContent">דלג אל התוכן</SkipLink>
          <Suspense>
            <Analytics />
          </Suspense>
          <Desktop>
            <DesktopHeader data={menu_data} locale={locale} />
          </Desktop>
          <Mobile>
            <MobileMenuCharge data={menu_data} />
          </Mobile>
          <>
            <StyledMain
              isContent={pathname.includes("content")}
              isParking={pathname === "/parking" || pathname === "/en/parking"}
              id="mainContent"
              ref={mainRef}
              role="main"
            >

              {children}

            </StyledMain>
            <FooterCharge data={footer_data} />
            <CookieBanner data={cookie_consent_data} />
          </>
        </LayoutProvider>
      </AppTypeProvider>
    </OneLinkScriptProvider>
  )
}

export default PazChargeLayout
